import { c as _c } from "react/compiler-runtime";
import { NotionEditor } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import { useNormsSave } from '../hooks/use-norms-save';
import { useBuilder } from '../store/provider';
import usePromptMentionExtensions from './prompt-mention/use-prompt-mention-extensions';
import NormsSuggestions from './suggestion/norms-suggestions';
const NormsView = () => {
  const $ = _c(29);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "agentBuilder.norms"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  const {
    state,
    actions,
    isReadOnly
  } = useBuilder();
  const save = useNormsSave();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      instructionBlocks: false
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const extensions = usePromptMentionExtensions(undefined, t1);
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h2 className="text-heading-2 text-primary">{t2}</h2>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp2);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <p className="text-body-2 text-tertiary">{t4}</p>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex flex-col gap-1">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = isReadOnly && "relative after:absolute after:inset-0 after:bg-secondary/40";
  let t8;
  if ($[13] !== t7) {
    t8 = cx("flex flex-col gap-4", t7);
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <NormsSuggestions />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = !isReadOnly;
  let t11;
  if ($[16] !== actions.editNorms || $[17] !== extensions || $[18] !== save || $[19] !== state.bundle.norms || $[20] !== t10) {
    t11 = <NotionEditor content={state.bundle.norms} onChange={actions.editNorms} onBlur={save} editable={t10} emitOnMount={false} extensions={extensions} />;
    $[16] = actions.editNorms;
    $[17] = extensions;
    $[18] = save;
    $[19] = state.bundle.norms;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== isReadOnly || $[23] !== t11 || $[24] !== t8) {
    t12 = <div inert={isReadOnly} className={t8}>{t9}{t11}</div>;
    $[22] = isReadOnly;
    $[23] = t11;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t6) {
    t13 = <div className="max-w-[800px] mx-auto px-6 py-8 sm:px-10 flex flex-col gap-8" data-id="norms-top">{t6}{t12}</div>;
    $[26] = t12;
    $[27] = t6;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
export default NormsView;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtitle;
}